module.exports = __webpack_public_path__ + "img/40.fd68177f.jpg";